module.exports = __webpack_public_path__ + "media/slot-game/2+2-729bd5be.svg";